import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusesComponent } from './statuses.component';
import { MaterialModule } from 'src/app/material/material.module';
import { CandidateReportComponent } from './candidate-report/candidate-report.component';
import { ChartsModule } from 'ng2-charts';
import { AgGridModule } from 'ag-grid-angular';

@NgModule({
  declarations: [
    StatusesComponent,
    CandidateReportComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ChartsModule,
    AgGridModule.withComponents(null)
  ]
})
export class StatusesModule { }
